import {HttpClientModule} from '@angular/common/http';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateModule, TranslateService} from '@ngx-translate/core';

import {NgxCaptchaModule} from 'ngx-captcha';
import {
  ProjectContactsSearchPersonComponent
} from "projects/admin/src/app/projects/search/selected-eligibility-application-dashboard/project-contacts/project-contacts-search-person/project-contacts-search-person/project-contacts-search-person.component";
import {
  ComponentModule,
  ECaseConfigService,
  ECaseDateFormatterPipe,
  EcaseHttpService,
  ECaseNavigationService,
  ECaseSnackBarService,
  ECaseSplashScreenService,
  ECaseTranslationLoaderService,
  LanguageService,
  LoginAuthenticationService,
  MaterialModule,
  MatProgressBarService,
  ParametersService,
  PendingChangesGuard,
  ProjectService,
  RefreshContentTabsService,
  SectionBreadCrumbService,
  SessionKeepAliveService,
  SharedModule,
  TitleService
} from 'synto-common';
import {FormModule} from 'synto-common/form-common';
import {ECaseNavigationModule} from 'synto-common/navigation-common';
import {SyntoCoreModule} from "synto-common/synto-core";
import {RoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserSupportComponent} from './browser-support/browser-support.component';
import {ECaseExternalRefereeComponent} from './external-referee/external-referee.component';
import {ECaseForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {GeneralDirectoryComponent} from './general-directory/general-directory.component';
import {GotoComponent} from './goto/goto.component';
import {ActivatorComponent} from './login/activator/activator.component';
import {AdfsSaml2LoginComponent} from './login/adfs-saml2-login/adfs-saml2-login.component';
import {ECaseRegisterComponent} from './login/authentication/register/register.component';
import {ECaseResetPasswordComponent} from './login/authentication/reset-password/reset-password.component';
import {
  TwoFactorAuthenticationComponent
} from './login/authentication/two-factor-authentication/two-factor-authentication.component';
import {CookiesPolicyDialogComponent} from './login/cookies-policy-dialog/cookies-policy-dialog.component';
import {LoginComponent} from './login/login.component';
import {
  PublicDocumentationDialogComponent
} from './login/public-documentation-dialog/public-documentation-dialog.component';
import {SyntoDocumentListModule} from 'explorer/synto-document-list/synto-document-list.module';
import {ShibbolethLoginComponent} from './login/shibboleth-login/shibboleth-login.component';
import {PrivacyComponent} from './privacy/privacy.component';
import {
  ComplementaryInformationFormComponent
} from './user-profile/complementary-information-form/complementary-information-form.component';
import {VersionCheckService} from './version-check.service';
//import { PaymentsTableComponent } from '../../projects/researcher/src/app/myresearch/applicant-portal/in-progress-applications/payments-table/payments-table.component';

export function initKeepAlive(service: SessionKeepAliveService) {
  return () => service.init();
}

@NgModule({
  declarations: [AppComponent,
    CookiesPolicyDialogComponent,
    LoginComponent,
    ShibbolethLoginComponent,
    ActivatorComponent,
    ECaseResetPasswordComponent,
    ECaseForgotPasswordComponent,
    ECaseRegisterComponent,
    TwoFactorAuthenticationComponent,
    AdfsSaml2LoginComponent,
    PrivacyComponent,
    BrowserSupportComponent,
    PublicDocumentationDialogComponent,
    GeneralDirectoryComponent,
    ECaseExternalRefereeComponent,
    ComplementaryInformationFormComponent,
    GotoComponent,
    ProjectContactsSearchPersonComponent
  ],
  imports: [
    NoopAnimationsModule,
    ECaseNavigationModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    MaterialModule,
    TranslateModule.forRoot(),
    RoutingModule,
    NgxCaptchaModule,
    ComponentModule,
    FormModule,
    SyntoCoreModule,
    SyntoDocumentListModule
  ],
  providers: [
    ECaseSplashScreenService, MatProgressBarService, LoginAuthenticationService, ECaseSnackBarService, TranslateService,
    LanguageService, RefreshContentTabsService, ECaseConfigService, ECaseNavigationService, ECaseDateFormatterPipe,
    ProjectService, ECaseTranslationLoaderService, EcaseHttpService, SectionBreadCrumbService, ParametersService,
    TitleService, VersionCheckService, PendingChangesGuard, {
      provide: APP_INITIALIZER,
      useFactory: initKeepAlive,
      deps: [SessionKeepAliveService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule {
}
